import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import image from "../assets/Images/contact/contact-us.avif"
import { sendContactMessage } from "../api/contactApi";
const BG_IMAGE =
 image;

export default function SplitContactFormBCG({ inModal = false }) {
  const location = useLocation();
  const isSales = location.pathname.startsWith("/sales");
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [fieldErrors, setFieldErrors] = useState({});
  const [consentChecked, setConsentChecked] = useState(false);
  const [consentError, setConsentError] = useState("");
  const [status, setStatus] = useState({ loading: false, ok: false, error: "" });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const headingText = isSales
    ? "Erfahren Sie mehr, wie Repexo Ihnen helfen kann ihre Vertriebsteams zu stärken und auszubauen."
    : "Erfahren Sie, wie Repexo Ihnen helfen kann, Ihr Gesundheitssystem zu transformieren.";
  const successColor = isSales ? "#78b7e4" : "#8DCDA4";
  const successColorHover = isSales ? "#5ea7dc" : "#8BC99A";

  useEffect(() => {
    if (!showSuccessPopup) return undefined;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showSuccessPopup]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (status.error) {
      setStatus((prev) => ({ ...prev, error: "" }));
    }
  };

  const validateForm = () => {
    const nextErrors = {};
    if (!form.name.trim()) nextErrors.name = "Bitte geben Sie Ihren Namen ein.";
    if (!form.email.trim()) {
      nextErrors.email = "Bitte geben Sie Ihre E-Mail-Adresse ein.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      nextErrors.email = "Bitte geben Sie eine gultige E-Mail-Adresse ein.";
    }
    if (!form.message.trim()) nextErrors.message = "Bitte geben Sie eine Nachricht ein.";
    setFieldErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (!consentChecked) {
      setConsentError(
        "Bitte stimmen Sie der Datenschutzerklarung zu, bevor Sie das Formular absenden."
      );
      return;
    }
    setConsentError("");
    setStatus({ loading: true, ok: false, error: "" });
    try {
      await sendContactMessage({
        name: form.name.trim(),
        email: form.email.trim(),
        message: form.message.trim(),
      });
      setStatus({ loading: false, ok: true, error: "" });
      setForm({ name: "", email: "", message: "" });
      setFieldErrors({});
      setConsentChecked(false);
      setShowSuccessPopup(true);
    } catch (error) {
      setStatus({
        loading: false,
        ok: false,
        error:
          error?.message ||
          "Beim Senden ist ein Fehler aufgetreten. Bitte erneut versuchen.",
      });
    }
  };

  return (
    <section
      id="section-contact"
      className={`w-full bg-white ${inModal ? "py-0" : "py-10"}`}
    >
      <div className={inModal ? "w-full" : "mx-auto container-app"}>
        {/* OUTER CARD */}
        <div
          className={`relative overflow-hidden bg-[#121313] shadow-[0_30px_70px_rgba(0,0,0,0.18)] ${
            inModal ? "rounded-2xl min-h-[520px]" : "rounded-[26px]"
          }`}
        >
          <div
            className={`grid grid-cols-1 lg:grid-cols-[1.02fr_1.18fr] ${
              inModal ? "min-h-[520px]" : "min-h-[420px]"
            }`}
          >
            {/* LEFT GREEN PANEL */}
            <div
              className={`bg-[#121313] flex flex-col justify-center ${
                inModal ? "px-8 py-8 sm:px-10 sm:py-10" : "px-10 py-12 sm:px-12 sm:py-14"
              }`}
            >
              <h2
                className={`font-medium text-white ${
                  inModal
                    ? "text-xl sm:text-2xl md:text-3xl leading-snug"
                    : "text-2xl sm:text-3xl md:text-4xl"
                }`}
              >
                {headingText}
              </h2>
              <p
                className={`max-w-[520px] text-white/85 ${
                  inModal ? "mt-4 text-[14px] leading-snug" : "mt-6 text-[15px] leading-6"
                }`}
              >
                Herkömmliche Lösungen reichen nicht aus, um neue Herausforderungen zu meistern. Um erfolgreich zu sein, müssen Anbieter alle Aspekte ihrer Organisation neu erfinden. Erfahren Sie, wie.
              </p>
            </div>

            {/* RIGHT IMAGE PANEL */}
            <div className="relative min-h-0">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${BG_IMAGE})` }}
              />
              <div className="absolute inset-0 bg-white/10" />

              {/* FORM CARD */}
              <div
                className={`relative flex h-full min-h-0 items-center justify-center ${
                  inModal ? "px-4 py-6 sm:px-8 sm:py-8" : "px-5 py-10 sm:px-10"
                }`}
              >
                <form
                  onSubmit={onSubmit}
                  className={`w-full rounded-[18px] border border-white/35 bg-white/70 shadow-[0_18px_60px_rgba(0,0,0,0.18)] backdrop-blur-md ${
                    inModal ? "max-w-[480px] p-5 sm:p-6" : "max-w-[720px] p-6 sm:p-8"
                  }`}
                >
                  <p
                    className={
                      inModal
                        ? "text-base font-medium text-neutral-700"
                        : "text-[18px] font-medium text-neutral-700"
                    }
                  >
                    Bitte geben Sie Ihre Angaben ein:
                  </p>

                  <div className={inModal ? "mt-3 space-y-3" : "mt-5 space-y-4"}>
                    <input
                      name="name"
                      value={form.name}
                      onChange={onChange}
                      placeholder="Name"
                      className={`w-full rounded-[10px] border bg-white px-4 text-neutral-800 outline-none ${
                        fieldErrors.name ? "border-red-400 focus:border-red-500" : "border-neutral-300 focus:border-neutral-400"
                      } ${
                        inModal ? "h-10 text-[14px]" : "h-11 text-[14px]"
                      }`}
                      required
                    />
                    {fieldErrors.name && (
                      <p className="mt-1 text-[12px] text-red-700">{fieldErrors.name}</p>
                    )}
                    <input
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={onChange}
                      placeholder="E-Mail"
                      className={`w-full rounded-[10px] border bg-white px-4 text-neutral-800 outline-none ${
                        fieldErrors.email ? "border-red-400 focus:border-red-500" : "border-neutral-300 focus:border-neutral-400"
                      } ${
                        inModal ? "h-10 text-[14px]" : "h-11 text-[14px]"
                      }`}
                      required
                    />
                    {fieldErrors.email && (
                      <p className="mt-1 text-[12px] text-red-700">{fieldErrors.email}</p>
                    )}
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={onChange}
                      placeholder="Nachricht"
                      rows={inModal ? 3 : 4}
                      className={`w-full resize-none rounded-[10px] border bg-white px-4 py-3 text-[14px] text-neutral-800 outline-none ${
                        fieldErrors.message ? "border-red-400 focus:border-red-500" : "border-neutral-300 focus:border-neutral-400"
                      } ${
                        inModal ? "min-h-[72px]" : ""
                      }`}
                      required
                    />
                    {fieldErrors.message && (
                      <p className="mt-1 text-[12px] text-red-700">{fieldErrors.message}</p>
                    )}
                  </div>

                  <div className={inModal ? "mt-4 flex justify-end" : "mt-6 flex items-end justify-end"}>
                    <div className="mr-auto">
                      <label className="flex items-start gap-2 text-xs leading-relaxed text-neutral-700">
                        <input
                          type="checkbox"
                          checked={consentChecked}
                          onChange={(e) => {
                            setConsentChecked(e.target.checked);
                            if (e.target.checked) setConsentError("");
                          }}
                          style={{ accentColor: isSales ? "#78b7e4" : "#8DCDA4" }}
                          className="mt-0.5 h-4 w-4 shrink-0 rounded border-neutral-400"
                        />
                        <span>
                          Ich habe die{" "}
                          <a
                            href={isSales ? "/sales/datenschutz" : "/medical/datenschutz"}
                            className="underline"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Datenschutzerklärung
                          </a>{" "}
                          gelesen und stimme der Verarbeitung meiner Daten zu.
                        </span>
                      </label>
                    </div>
                    <button
                      type="submit"
                      disabled={status.loading}
                      className="btn btn-bg text-gray-900 disabled:cursor-not-allowed disabled:opacity-75"
                    >
                      {status.loading ? (
                        <span className="inline-flex items-center gap-2">
                          <svg
                            className="h-4 w-4 animate-spin"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                          >
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.3" strokeWidth="4" />
                            <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                          </svg>
                          Wird gesendet...
                        </span>
                      ) : (
                        "Einreichen"
                      )}
                    </button>
                  </div>

                  {status.error && (
                    <p className="mt-3 text-right text-[12px] font-medium text-red-700">
                      {status.error}
                    </p>
                  )}
                  {consentError && (
                    <p className="mt-3 text-right text-[12px] text-red-700">
                      {consentError}
                    </p>
                  )}
                </form>
                {status.loading && (
                  <div className="absolute inset-0 z-20 flex items-center justify-center rounded-[18px] bg-black/40 backdrop-blur-[2px]">
                    <div className="rounded-xl bg-white/95 px-5 py-3 text-[13px] font-semibold text-neutral-700 shadow-lg">
                      Nachricht wird gesendet...
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showSuccessPopup && (
        <div
          className="fixed inset-0 z-[140] flex items-center justify-center bg-black/35 backdrop-blur-md p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="contact-success-title"
        >
          <div className="w-full max-w-md rounded-2xl bg-white px-7 py-8 text-center shadow-[0_30px_70px_rgba(0,0,0,0.2)]">
            <div
              className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full text-white"
              style={{ backgroundColor: successColor }}
            >
              <span className="text-3xl leading-none">✓</span>
            </div>
            <h3 id="contact-success-title" className="text-3xl font-semibold text-neutral-800">
              Erfolgreich gesendet!
            </h3>
            <p className="mt-3 text-[15px] leading-7 text-neutral-600">
              Vielen Dank für Ihre Nachricht. Wir habe Ihre Anfrage erhalten und melden uns so schnell wie möglich zurück.
            </p>
            <button
              type="button"
              className="mt-6 inline-flex min-w-[190px] items-center justify-center rounded-lg px-5 py-3 text-sm font-semibold text-white transition-colors"
              style={{ backgroundColor: successColor }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = successColorHover;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = successColor;
              }}
              onClick={() => {
                window.location.href = isSales ? "/sales" : "/medical";
              }}
            >
              Zur Startseite
            </button>
          </div>
        </div>
      )}
    </section>
  );
}